/** @format */

import "aos/dist/aos.css";
import AOS from "aos";
import { useEffect } from "react";
import "./App.css";
import Header from "./comps/header/header";
import Home from "./comps/home/home";
import CustomCursor from "./comps/cursol.tsx";

import Card from "./comps/home/sevices-card";
import Aboutus from "./comps/home/aboutus";
import Numbers from "./comps/home/numbers.tsx";
import MoreAboutUs from "./comps/MoreAboutUs/MoreAboutUs.jsx";
import Blog from "./comps/MoreAboutUs/componts/blog.tsx";
import Test from "./comps/MoreAboutUs/componts/testing.tsx";
import Testimonials from "./comps/home/testimonials";
import ContactInfo from "./comps/MoreAboutUs/componts/ContactInfo.tsx";
import Footer from "./comps/home/footer";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";


function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <Router>
      <>
        <Routes>
          {/* Render Home Page */}
          <Route
            path="/"
            element={
              <div>
                <CustomCursor />
                <Header />
                <section id="home">
                  <Home />
                </section>
                <section id="services">
                  <div>
                    <Card />
                  </div>
                </section>
                <section id="aboutus">
                  <div>
                    <Aboutus />
                  </div>
                </section>
                <section id="numbers">
                  <div>
                    <Numbers />
                  </div>
                </section>
                <section id="testimonials">
                  <div>
                    <Testimonials />
                  </div>
                </section>
                <section id="contactus">
                  <ContactInfo />
                </section>
                <section id="footer">
                  <div>
                    <Footer />
                  </div>
                </section>
              </div>
            }
          />
          {/* Render More About Us Page */}
          <Route
            path="/MoreAboutUs"
            element={
              <>
                <CustomCursor />
                <MoreAboutUs />
              </>
            }
          />
          {/* Route for testing */}
          <Route path="/test" element={<Test />} />
          {/* Route for testing */}
          <Route path="/GrandShopRwandablog" element={<Blog />} />
        </Routes>
      </>
    </Router>
  );
}

export default App;
